/** @jsxImportSource @emotion/react */
"use client";

import {
  matchSelectableGuide,
  useCurrentGuide,
  usePlayer,
} from "@packages/media";
import type { Track } from "@packages/sdk";

import { SelectGuideList } from "./SelectGuideList.emotion";

export const SelectGuideContent = () => {
  const { currentItem, guides } = useCurrentGuide();
  const player = usePlayer();

  if (currentItem?.type === "radio_song") return null;

  const options: Track[] = [];
  for (const guide of guides) {
    let closestTimeDiff: number = 1000000;
    let closestTimeTrack: Track | null = null;
    for (const track of guide.tracks) {
      const timeDiff = Math.abs(
        track.duration - currentItem.selected_audio.duration,
      );
      if (timeDiff < closestTimeDiff) {
        closestTimeDiff = timeDiff;
        closestTimeTrack = track;
      }
    }
    if (closestTimeTrack)
      options.push({ ...closestTimeTrack, guide_ids: guide.guide_ids });
  }

  return (
    <SelectGuideList
      key={"mediaMenu_selectGuideList"}
      onGuideSelection={(newGuides) => {
        const choice = options.find((opt) =>
          matchSelectableGuide(opt.guide_ids, newGuides),
        );
        return player?.switchTo(choice);
      }}
      options={guides}
      selectedGuides={
        guides.find((g) =>
          matchSelectableGuide(
            g.guide_ids,
            currentItem?.selected_audio?.guide_ids,
          ),
        )?.guide_ids
      }
    />
  );
};
